import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import { useEmpresa } from "../../../contexts/EmpresaContext";
import LayoutDesktop from "../../../layouts/LayoutDesktop";

import { db } from "../../../config/firebase";
import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { obterProximoCodigoSequencialFornecedor } from "./obterProximoCodigoSequencialFornecedor"; // ou copie a função no mesmo arquivo

function NovoFornecedor() {
  const { tema } = useTheme();
  const { usuario: usuarioLogado } = useAuth();
  const { modoGlobal, empresaAtual } = useEmpresa();
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [contato, setContato] = useState("");
  const [telefone, setTelefone] = useState("");
  const [email, setEmail] = useState("");
  const [endereco, setEndereco] = useState("");
  const [fatura, setFatura] = useState(false);
  const [observacoes, setObservacoes] = useState("");

  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [carregando, setCarregando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    if (!usuarioLogado?.grupoId) {
      setErro(
        "Usuário logado não possui grupo definido. Verifique o cadastro do Gestor."
      );
      return;
    }

    if (!nome.trim()) {
      setErro("Informe o nome do fornecedor.");
      return;
    }

    const grupoId = usuarioLogado.grupoId;
    const grupoNome = usuarioLogado.grupoNome || usuarioLogado.grupo || null;
    // ✅ usa o escopo atual (EmpresaContext) para não "sumir" da lista
    const empresaId = !modoGlobal && empresaAtual?.id ? empresaAtual.id : null;
    const empresaNome = !modoGlobal && empresaAtual?.nome ? empresaAtual.nome : null;

    setCarregando(true);

    try {
      const sequencial = await obterProximoCodigoSequencialFornecedor(grupoId);
      const codigo = `FN${String(sequencial).padStart(4, "0")}`;

      const novaRef = doc(collection(db, "fornecedores"));

      await setDoc(novaRef, {
        codigo,
        codigoSequencial: sequencial,

        nome: nome.trim(),
        contato: contato.trim() || null,
        telefone: telefone.trim() || null,
        email: email.trim() || null,
        // evitar acento no nome do campo
        endereco: endereco.trim() || null,
        fatura: !!fatura,
        observacoes: observacoes.trim() || null,

        grupoId,
        grupoNome: grupoNome || null,
        empresaId,
        empresaNome,

        criadoPor: usuarioLogado?.uid || null,
        criadoEm: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      setSucesso(`Fornecedor criado com sucesso (código ${codigo}).`);
      setNome("");
      setContato("");
      setTelefone("");
      setEmail("");
      setEndereco("");
      setFatura(false);
      setObservacoes("");
    } catch (err) {
      console.error(err);
      setErro("Erro ao salvar fornecedor. Tente novamente.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <LayoutDesktop
      tema={tema}
      titulo="Novo Fornecedor"
      subtitulo="Cadastros / Fornecedores / Novo"
    >
      <section style={{ width: "100%" }}>
        <div
          className="pc-card"
          style={{
            width: "100%",
            paddingLeft: 40,
            paddingRight: 40,
            boxSizing: "border-box",
          }}
        >
          <header className="pc-table-header">
            <div className="pc-table-header-text">
              <h3>Cadastro de fornecedor</h3>
              <p>Cadastre fornecedores vinculados ao grupo e empresa atuais.</p>
            </div>
          </header>

          {erro && (
            <div
              style={{
                marginTop: 12,
                padding: 8,
                borderRadius: 8,
                background: "#7f1d1d",
                color: "#fecaca",
                fontSize: 14,
              }}
            >
              {erro}
            </div>
          )}

          {sucesso && (
            <div
              style={{
                marginTop: 12,
                padding: 8,
                borderRadius: 8,
                background: "#14532d",
                color: "#bbf7d0",
                fontSize: 14,
              }}
            >
              {sucesso}
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            style={{
              marginTop: 12,
              maxWidth: 720,
              marginLeft: "auto",
              marginRight: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            {/* Nome */}
            <label>
              <span style={{ fontSize: 14 }}>Nome</span>
              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
            </label>

            {/* Contato */}
            <label>
              <span style={{ fontSize: 14 }}>Contato</span>
              <input
                type="text"
                value={contato}
                onChange={(e) => setContato(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
            </label>

            {/* Telefone */}
            <label>
              <span style={{ fontSize: 14 }}>Telefone</span>
              <input
                type="text"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
            </label>

            {/* Email */}
            <label>
              <span style={{ fontSize: 14 }}>Email</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
            </label>

            {/* Endereço */}
            <label>
              <span style={{ fontSize: 14 }}>Endereço</span>
              <input
                type="text"
                value={endereco}
                onChange={(e) => setEndereco(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                }}
              />
            </label>

            {/* Fatura */}
            <label>
              <span style={{ fontSize: 14 }}>Fatura</span>
              <select
                value={fatura ? "sim" : "nao"}
                onChange={(e) => setFatura(e.target.value === "sim")}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                  color: "inherit",
                }}
              >
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </label>

            {/* Observações */}
            <label>
              <span style={{ fontSize: 14 }}>Observações</span>
              <textarea
                value={observacoes}
                onChange={(e) => setObservacoes(e.target.value)}
                rows={3}
                style={{
                  width: "100%",
                  padding: "9px 11px",
                  marginTop: 4,
                  borderRadius: 8,
                  border: "1px solid #334155",
                  
                  resize: "vertical",
                }}
              />
            </label>

            {/* Ações */}
            <div
              style={{
                marginTop: 16,
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
              }}
            >
              <button
                type="button"
                className="pc-btn-secundario"
                onClick={() => navigate("/cadastros/fornecedores")}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="pc-btn-primario"
                disabled={carregando}
              >
                {carregando ? "Salvando..." : "Salvar fornecedor"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </LayoutDesktop>
  );
}

export default NovoFornecedor;
